var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBounceCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 368,
    viewBox: "0 0 545 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M505.065 3.5H8.5V328.674M505.065 3.5V328.674H8.5M505.065 3.5L521.5 19.9348V345.108H24.9348L8.5 328.674",
    stroke: "#FF4343",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 329L25.5 345.108H521.5L505.065 328.674L9.5 329Z",
    fill: "#C22626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.5 345.108V19.9348L505.065 3.5V328.674L521.5 345.108Z",
    fill: "#FF4343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175 90.0634L218.332 133.415V214.548L175 257.899V90.0634Z",
    fill: "#FF4343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.561 84L223.642 128.101H306.385L350.466 84H179.561Z",
    fill: "#FF4343"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356 89.0898L311.695 133.415V214.548L356 258.873V89.0898Z",
    fill: "#FF4343"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.523 263L223.642 219.861H306.385L349.504 263H180.523Z",
    fill: "#FF4343"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 368.5V345.5H521.926V0.5H545V368.5H0.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounceCap);
export default __webpack_public_path__ + "static/media/bounce-cap.09c63b365b86591780ac250436a41216.svg";
export { ForwardRef as ReactComponent };